import { createMachine } from '@/lib/stateMachine';

export const DOCUMENT_STATUSES = {
  DRAFT: { label: 'Draft', color: 'gray' },
  REVIEWING: { label: 'Reviewing', color: 'blue' },
  APPROVED: { label: 'Approved', color: 'teal' },
  REJECTED: { label: 'Rejected', color: 'red' },
  RETURNED: { label: 'Returned', color: 'yellow' },
  RELEASED: { label: 'Released', color: 'green' },
  ARCHIVED: { label: 'Archived', color: 'slate' },
};

export const documentMachineConfig = {
  initial: 'DRAFT',
  reviewGroupOrder: ['processOwners', 'qmrQa', 'managementApprovers'],
  states: {
    DRAFT: {
      actions: {
        submit: { next: 'REVIEWING', actorRule: 'creator' },
      },
    },
    REVIEWING: {
      actions: {
        approve: { next: 'dynamic', actorRule: 'pipeline' },
        reject: { next: 'REJECTED', actorRule: 'pipeline', resetIndex: true },
        returnToRequestor: { next: 'RETURNED', actorRule: 'pipeline', resetIndex: true },
      },
    },
    RETURNED: {
      actions: {
        submit: { next: 'REVIEWING', actorRule: 'creator', resetIndex: true }, // F8: restart at PO
      },
    },
    APPROVED: {
      actions: {
        release: { next: 'RELEASED', actorRule: 'role', requiredRole: ['QA'] },
      },
    },
    RELEASED: {
      actions: {
        archive: { next: 'ARCHIVED', actorRule: 'role', requiredRole: ['QA'] },
        newRevision: { next: null, actorRule: 'authorized' },
      },
    },
    REJECTED: {
      actions: {},
    },
    ARCHIVED: {
      actions: {},
    },
  },
};

export const documentMachine = createMachine(documentMachineConfig);
